module.exports = __webpack_public_path__ + "img/step-img1.185e8af0.png";